var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCoin = function SvgCoin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coin-Horizontal--Streamline-Core"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coin-horizontal"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99997 10.6465C11.795 10.6465 14.8714 8.75335 14.8714 6.41797V9.5894C14.8714 11.9247 11.795 13.818 7.99997 13.818C4.20498 13.818 1.12854 11.9247 1.12854 9.5894V6.41797C1.12854 8.75335 4.20498 10.6465 7.99997 10.6465Z",
    fill: "#FECA06"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.99997 10.6465C11.795 10.6465 14.8714 8.75335 14.8714 6.41797V9.5894C14.8714 11.9247 11.795 13.818 7.99997 13.818C4.20498 13.818 1.12854 11.9247 1.12854 9.5894V6.41797C1.12854 8.75335 4.20498 10.6465 7.99997 10.6465Z",
    stroke: "#7B6200",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1742",
    d: "M1.12854 6.41607C1.12854 6.97138 1.30627 7.52124 1.6516 8.03428C1.99692 8.54731 2.50306 9.01346 3.14113 9.40612C3.77921 9.79878 4.53671 10.1103 5.37039 10.3228C6.20407 10.5353 7.0976 10.6446 7.99997 10.6446C8.90234 10.6446 9.79587 10.5353 10.6296 10.3228C11.4632 10.1103 12.2207 9.79878 12.8588 9.40612C13.4969 9.01346 14.003 8.54731 14.3483 8.03428C14.6937 7.52124 14.8714 6.97138 14.8714 6.41607C14.8714 5.86077 14.6937 5.3109 14.3483 4.79787C14.003 4.28483 13.4969 3.81868 12.8588 3.42602C12.2207 3.03336 11.4632 2.72189 10.6296 2.50938C9.79587 2.29688 8.90234 2.1875 7.99997 2.1875C7.0976 2.1875 6.20407 2.29688 5.37039 2.50938C4.53671 2.72189 3.77921 3.03336 3.14113 3.42602C2.50306 3.81868 1.99692 4.28483 1.6516 4.79787C1.30627 5.3109 1.12854 5.86077 1.12854 6.41607Z",
    fill: "#FFCB03"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 1743",
    d: "M1.12854 6.41607C1.12854 6.97138 1.30627 7.52124 1.6516 8.03428C1.99692 8.54731 2.50306 9.01346 3.14113 9.40612C3.77921 9.79878 4.53671 10.1103 5.37039 10.3228C6.20407 10.5353 7.0976 10.6446 7.99997 10.6446C8.90234 10.6446 9.79587 10.5353 10.6296 10.3228C11.4632 10.1103 12.2207 9.79878 12.8588 9.40612C13.4969 9.01346 14.003 8.54731 14.3483 8.03428C14.6937 7.52124 14.8714 6.97138 14.8714 6.41607C14.8714 5.86077 14.6937 5.3109 14.3483 4.79787C14.003 4.28483 13.4969 3.81868 12.8588 3.42602C12.2207 3.03336 11.4632 2.72189 10.6296 2.50938C9.79587 2.29688 8.90234 2.1875 7.99997 2.1875C7.0976 2.1875 6.20407 2.29688 5.37039 2.50938C4.53671 2.72189 3.77921 3.03336 3.14113 3.42602C2.50306 3.81868 1.99692 4.28483 1.6516 4.79787C1.30627 5.3109 1.12854 5.86077 1.12854 6.41607Z",
    stroke: "#7B6200",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 3454",
    d: "M8 10.6445V13.816",
    stroke: "#7B6200",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.29993 9.98438V13.1556",
    stroke: "#7B6200",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.7 9.98438V13.1556",
    stroke: "#7B6200",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCoin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "coin.f30089b426d54bc384a46720a6aedd69.svg";